<meta name="referrer" content="no-referrer" />

<!-- Loading Screen -->

@if (isResetting) {
  <div class="wrapper center-1"
    >
    <div class="inner">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

<!-- Reset Page-->

@if (!isResetting) {
  <div class="container reset-password-container"
    >
    <!-- Archipelago logo -->
    <div class="row justify-content-center">
      <div class="col login-image">
        <img [src]="('assets/images/archipelago-blue-email.png' | sanitizeUrl)" class="center" width="300" />
      </div>
    </div>
    <!-- Page title -->
    <div class="row">
      <h1 i18n class="login-title">
      Change Password
    </h1>
    </div>
    <form [formGroup]="resetForm" class="row">
      <mat-form-field appearance="outline">
        <mat-label i18n>
        New Password
      </mat-label>
        <input matInput
          required
          formControlName="newPassword"
          [type]="newPasswordHide ? 'password' : 'text'">
          <button mat-icon-button
            matSuffix
            type="button"
            (click)="newPasswordHide = !newPasswordHide">
            <mat-icon>
              {{newPasswordHide ? 'visibility_off' : 'visibility'}}
            </mat-icon>
          </button>
          <mat-error i18n>
        {passwordError, select, Minimum length 8 required {Minimum length 8 required} Maximum length 50 exceeded {Maximum length 50 exceeded} Required {Required}}
      </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label i18n>
        Confirm Password
      </mat-label>
          <input matInput
            required
            formControlName="confirmPassword"
            [type]="confirmPasswordHide ? 'password' : 'text'"
            (keyup.enter)="attemptReset()">
            <button mat-icon-button
              matSuffix
              type="button"
              (click)="confirmPasswordHide = !confirmPasswordHide">
              <mat-icon>
                {{confirmPasswordHide ? 'visibility_off' : 'visibility'}}
              </mat-icon>
            </button>
            <mat-error i18n>
        Passwords Must Match
      </mat-error>
          </mat-form-field>
        </form>
        <div class="row justify-content-center">
          <button i18n mat-flat-button
            class="login-button"
            (keyup.enter)="attemptReset()"
            (click)="attemptReset()">
      Confirm
    </button>
        </div>
        <div class="row justify-content-center bottom-row" align="center">
          <p i18n style="font-size:medium; font-weight: bold; color: #003F61;">
      <a routerLink="/login" routerLinkActive="active" ariaCurrentWhenActive="page">
        Back to Login
      </a>
    </p>
        </div>
      </div>
    }
